import * as CubeTree from '../cubeTree/index';
import * as StageStatus from '../stageStatus/index';
import Update from '../update/index';

// 获取图纸保存数据
function getSavePaperData(): SaveDataTree {
    // 卧柜暂时不做此计算
    !StageStatus.isTopFace() && Update.updateAxisSync();

    return CubeTree.makeSaveDataTree();
}

function findParentIdByCubeId(cubeId: CubeId): CubeId|null {
    return CubeTree.findParentIdByCubeId(cubeId);
}

function findCubeByType(type: CubeType): CubeId[] {
    return CubeTree.findCubeByType(type);
}

function findChildCubeIds(cubeId: CubeId, skip: CubeId[] = []): Array<CubeId> {
    return CubeTree.findChildCubeIdsWithSkip(cubeId, skip);
}

function findCubeInStage(): CubeId[] {
    return CubeTree.findCubeInStage();
}

function findCubeReader(target: CubeId): CubeReader|null {
    return CubeTree.findCubeReader(target);
}

export {
    getSavePaperData,
    findParentIdByCubeId,
    findCubeByType,
    findChildCubeIds,
    findCubeInStage,
    findCubeReader
};
